package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class EventTimerDto(
    val status: String,
    val elapsedSeconds: Long,
    val lastStartedAt: String? = null
)

@Serializable
data class EventTimerActionRequest(
    val action: String
)
